import IconBase from "./IconBase";

// Installed apps as a tray of equal tiles — deliberately even, where Dashboard
// is deliberately uneven, so the two never read as the same icon.
const AppsIcon = (props) => (
    <IconBase {...props}>
        <rect x="3.5" y="3.5" width="7" height="7" rx="2.25" />
        <rect x="13.5" y="3.5" width="7" height="7" rx="2.25" />
        <rect x="3.5" y="13.5" width="7" height="7" rx="2.25" />
        <rect x="13.5" y="13.5" width="7" height="7" rx="2.25" />
    </IconBase>
);

export default AppsIcon;
